export enum ActivityType {
    Karting = "karting",
    TheParkPlayground = "theparkplayground",
    Petangue = "petangue",
    Time = "time",
    Points = "points",
}
